import { logNetworkError } from './logNetworkError';

export const errorHandler = (error: unknown, onError?: (error: unknown) => void) => {
   if (onError) {
      onError(error);
   }
   logNetworkError(error);
};
